<template>
  <div class="yx-assitant-page main-layout">
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="我的老师" :back="false"></c-title>
      <div class="div-scroll">
        <div
          style="padding: 20px"
          v-if="
            JSON.stringify(counselor) != '{}' ||
            JSON.stringify(classTeacher) != '{}'
          "
        >
          <div style="width: 70%; margin: 0 auto 20px">
            <el-descriptions
              title="辅导员信息"
              :column="1"
              border
              :labelStyle="{ width: '150px' }"
            >
              <el-descriptions-item
                :label="item.label"
                v-for="(item, index) in assistantForm"
                :key="index"
              >
                <span>{{ counselor[item.model] }}</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div style="width: 70%; margin: 0 auto">
            <el-descriptions
              title="班导师信息"
              :column="1"
              border
              :labelStyle="{ width: '150px' }"
            >
              <el-descriptions-item
                :label="item.label"
                v-for="(item, index) in assistantForm"
                :key="index"
              >
                <span>{{ classTeacher[item.model] }}</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <empty v-else />
      </div>
    </el-card>
  </div>
</template>

<script>
import Empty from "@/components/Empty/index";
import Configs from "./data/mustSee.js";
import { mapState } from 'vuex';
export default {
  name: "",
  components: {
    Empty,
  },
  data() {
    let { assistantForm } = Configs(this);
    return {
      assistantForm,
      classTeacher: {},
      counselor: {},
    };
  },
  computed:{
    ...mapState('dic',['SUCCESS_CODE'])
  },
  created() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    getInfo() {
      this.$http.get("/account/base/teacher/myTeacher").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          console.log(res);
          this.classTeacher = res.data.classTeacher || {};
          this.counselor = res.data.counselor || {};
          console.log(JSON.stringify(this.counselor) != '{}')
          console.log(JSON.stringify(this.classTeacher) != '{}')
        }
      });
    },
  },
};
</script>
